import React from "react";
import { classNames } from "../utils";
import { DocumentDuplicateIcon as DuplicateIcon } from "@heroicons/react/24/outline";
import ReactTooltip from "react-tooltip";
import { useApplicationToast } from "../webcontent/ApplicationToastProvider";

type Props = {
  textToCopy: string;
  tooltip?: string;
  iconClassName?: string;
};

const CopyIcon = ({
  textToCopy,
  tooltip,
  iconClassName = "w-4 h-4",
}: Props) => {
  const { showPushToast } = useApplicationToast();

  function handleCopy(text: string) {
    window.navigator.clipboard.writeText(text);
    showPushToast?.({
      message: "Text copied to clipboard.",
      duration: 2000,
    });
  }

  return (
    <span
      className="p-0.5 cursor-pointer text-gray-500 hover:text-gray-700"
      onClick={() => handleCopy(textToCopy)}
    >
      <DuplicateIcon data-tip={tooltip} className={classNames(iconClassName)} />
      {tooltip && (
        <ReactTooltip
          className="hover:visible:opacity-1"
          delayHide={100}
          effect="solid"
        />
      )}
    </span>
  );
};

export default CopyIcon;
